import { render, staticRenderFns } from "./TypoPTC.vue?vue&type=template&id=7adc66a4&scoped=true&"
import script from "./TypoPTC.vue?vue&type=script&lang=js&"
export * from "./TypoPTC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7adc66a4",
  null
  
)

export default component.exports